import { Controller, useFormContext } from 'react-hook-form'
import { Form, Image, Jumbotron } from 'react-bootstrap'
import Dropzone from 'react-dropzone'
import { InfoButton } from './InfoButton'

const ImageDrop = ({
  controlId,
  label,
  onInfoClick,
  imgSrc,
  helperText,
  maxSize
}) => {
  const {
    control,
    setError,
    formState: { errors }
  } = useFormContext()

  return (
    <Controller
      control={control}
      name={controlId}
      render={({ field: { onChange, value } }) => (
        <Dropzone
          accept={{
            'image/*': ['.svg', '.png', '.jpg', '.jpeg', '.webp', '.gif']
          }}
          maxFiles={1}
          maxSize={maxSize}
          multiple={false}
          onDropAccepted={(files) => onChange(files[0])}
          onDropRejected={() => {
            onChange(null)
            setError(controlId, {
              type: 'validation',
              message: 'Invalid image'
            })
          }}
          onError={(error) => {
            onChange(null)
            setError(controlId, error)
          }}
        >
          {({ getRootProps, getInputProps }) => (
            <div {...getRootProps()}>
              <Form.Group controlId={controlId}>
                <Form.Label className='font-weight-bold'>{label}</Form.Label>
                <InfoButton
                  label={label + ' Info'}
                  onClick={(e) => {
                    e.stopPropagation()
                    onInfoClick()
                  }}
                />
                <Jumbotron
                  style={{ height: '300px' }}
                  className={`mw-100 mh-100 w-auto p-0 mb-0 bg-transparent form-control ${
                    errors[controlId] ? 'is-invalid' : ''
                  }`}
                >
                  <input id={controlId} {...getInputProps()} />
                  <Image
                    src={value ? URL.createObjectURL(value) : imgSrc}
                    alt=''
                    className='mw-100 mh-100 w-auto h-auto'
                  />
                </Jumbotron>
                <Form.Text className='text-muted'>
                  <div>
                    Click the image or drag a new file here to upload a
                    replacement
                  </div>
                  <div>{helperText}</div>
                </Form.Text>
                <Form.Control.Feedback
                  type='invalid'
                  className={errors[controlId] && 'd-block'}
                >
                  {errors[controlId]?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </div>
          )}
        </Dropzone>
      )}
    />
  )
}
export { ImageDrop }
